<div class="strength-state">{{ strengthState }}</div>
